var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCookiesIcon = function SvgCookiesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3775_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82833 9.33805L8.83262 9.33803C9.22267 9.33563 9.53823 9.64854 9.54061 10.0337C9.54299 10.4181 9.23267 10.7343 8.84379 10.738C8.45447 10.7352 8.14219 10.4209 8.14075 10.0361L8.14078 10.0361L8.1407 10.0306L8.14063 10.0188C8.14154 9.64334 8.448 9.33711 8.82833 9.33805Z",
    fill: "#AEAEB2",
    stroke: "#AEAEB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4284 11.738L12.4327 11.738C12.8228 11.7356 13.1383 12.0485 13.1407 12.4337C13.1431 12.818 12.8328 13.1342 12.4439 13.138C12.0546 13.1352 11.7423 12.8209 11.7409 12.4361L11.7409 12.4361L11.7408 12.4305L11.7407 12.4188C11.7416 12.0433 12.0481 11.7371 12.4284 11.738Z",
    fill: "#AEAEB2",
    stroke: "#AEAEB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6284 15.3381L13.6327 15.338C14.0227 15.3356 14.3383 15.6485 14.3407 16.0337C14.343 16.4181 14.0327 16.7343 13.6438 16.738C13.2545 16.7352 12.9422 16.4209 12.9408 16.0361L12.9408 16.0361L12.9407 16.0306L12.9407 16.0188C12.9416 15.6433 13.2481 15.3371 13.6284 15.3381Z",
    fill: "#AEAEB2",
    stroke: "#AEAEB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82833 14.138L8.83262 14.138C9.22267 14.1356 9.53823 14.4485 9.54061 14.8337C9.54299 15.218 9.23267 15.5343 8.84379 15.538C8.45447 15.5352 8.14219 15.2209 8.14075 14.8361L8.14078 14.8361L8.1407 14.8306L8.14063 14.8188C8.14154 14.4433 8.448 14.1371 8.82833 14.138Z",
    fill: "#AEAEB2",
    stroke: "#AEAEB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 7.97056 16.0294 12 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3775_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgCookiesIcon as ReactComponent };
export default __webpack_public_path__ + "cookies-icon.svg";